import { useState } from "react";
import "../rating.css";
import { computeRatingStats, getStarArray } from "../utility/ratingUtils";

const Rating = ({ ratingByOthersGroupByData, ratingByOthersData }) => {
    const ratingCount = 100;
    //console.log("ratingByOthersGroupByData",ratingByOthersGroupByData?.get(5)?.length || 0)

    //AR = 1*a+2*b+3*c+4*d+5*e/(R)

    const averageRating = (1*ratingByOthersGroupByData?.get(1)?.length || 0 + 
    2*ratingByOthersGroupByData?.get(2)?.length || 0 + 
    3*ratingByOthersGroupByData?.get(3)?.length || 0 +
    4*ratingByOthersGroupByData?.get(4)?.length || 0 +
    5*ratingByOthersGroupByData?.get(5)?.length || 0 )/ ratingByOthersData?.length || 0;

    const averageRatingRound = Math.round(averageRating * 10) /10;


    const checkedStar = Math.round(averageRatingRound);
    const uncheckedStar = 5 - checkedStar;

    const { average, total, breakdown } = computeRatingStats(ratingByOthersData);


    return (
        <div className="uic-section details-user-info-responsive m-2 p-2">
                <p className="uic-section-label mb-2">Ratings & reviews</p>

                <div className="uic-rating-summary">
                    {/* Left — big score */}
                    <div className="uic-rating-score">
                        <div>{}</div>
                        <span className="uic-rating-score__number">{average || 0}</span>
                        <div className="uic-rating-stars">
                            {getStarArray(average).map((filled, i) => (
                            <i key={i} className={`fa ${filled ? "fa-star" : "fa-star-o"} uic-star`} />
                            ))}
                        </div>
                        <span className="uic-rating-score__count">{total > 1 ? `${total} ratings` : "rating"} </span>
                    </div>

                    {/* Right — breakdown bars */}
                    <div className="uic-rating-bars">
                    {[5, 4, 3, 2, 1].map(star => {
                        const count = breakdown[star] || 0;
                        const pct = total ? Math.round((count / total) * 100) : 0;
                        
                        return (
                        <div key={star} className="uic-bar-row">
                            <span className="uic-bar-row__num">{star}</span>
                            <i className="fa fa-star uic-star uic-star--sm" />
                            <div className="uic-bar-track">
                            <div className="uic-bar-fill" style={{ width: `${pct}%` }} />
                            </div>
                            <span className="uic-bar-row__count">{count}</span>
                        </div>
                        );
                    })}
                    </div>
                </div>
        </div>
    );
}

export default Rating;
